// Phase 6 — shared page header for upgraded native-Angular screens.
// The upgraded list pages (RoleListComponent, GradeTemplatesListComponent) share one shell:
// an admin-red mat-toolbar carrying a title plus trailing action(s). This owns the toolbar and
// title; the trailing actions are PROJECTED so each page supplies its own button(s) — the action
// area varies per screen (add, tooltip-or-not, multiple buttons, none). Tweak the shared chrome
// (fill, title type ramp) here and every upgraded page moves together.
// Lives under ng/components/ (cross-cutting, like confirm-dialog / my-switch).
import { Component, input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'page-header',
    standalone: true,
    imports: [MatToolbarModule],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.css',
})
export class PageHeaderComponent {
    /** Toolbar title text. */
    title = input.required<string>();
}
